import { useMutation, useQueryClient } from "@tanstack/react-query";
import api from "../../services/api";

export const useUpdateEnquiryStatus = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ id, status }) => {
      const res = await api.patch(`/enquiry/${id}/status`, { status });
      return res.data;
    },
    onSuccess: (_, { id }) => {
      queryClient.invalidateQueries({ queryKey: ["enquiryList"] });
      queryClient.invalidateQueries({ queryKey: ["enquiry", id] });
    },
  });
};
